
import { useEffect, useState } from 'react';

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      try {
        const scrollTop = window.scrollY;
        const docHeight =
          document.documentElement.scrollHeight - window.innerHeight;

        // Guard against division by zero or negative values
        if (docHeight > 0) {
          const rawProgress = (scrollTop / docHeight) * 100;
          // Clamp the value between 0 and 100
          const clampedProgress = Math.min(Math.max(rawProgress, 0), 100);
          setProgress(clampedProgress);
        } else {
          setProgress(0);
        }
      } catch (err) {
        // In case something unexpected happens, log the error and reset progress
        console.error('Error calculating scroll progress:', err);
        setProgress(0);
      }
    };

    // Attach the scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Run once in case the component mounts after a scroll has already occurred
    handleScroll();

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <div className="scroll-progress" style={{ width: `${progress}%` }}></div>;
}
